import { render, staticRenderFns } from "./PayslipDetail.vue?vue&type=template&id=67a0cd28&scoped=true"
import script from "./PayslipDetail.vue?vue&type=script&lang=js"
export * from "./PayslipDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a0cd28",
  null
  
)

export default component.exports